module.exports = __webpack_public_path__ + "img/202509-2_11.57b07c6d.jpg";